import { ChevronRightIcon, Text } from '@cash-me/react-components'

import { pushDataLayer } from 'utils/push-data-layer'

import { HelpFaq } from './help.model'
import { SimulatorLink } from './simulator-link'
import * as S from './styles'

const answerColor = 'var(--colors-neutral-text-contrast-default)'

const otherProducts = [
  { name: 'Crédito com Garantia de Imóvel', href: '/emprestimo-com-garantia-de-imovel' },
  { name: 'Crédito para Construção', href: '/financiamento-para-construcao' },
  { name: 'Crédito para Condomínios', href: '/condo' },
  { name: 'Crédito para Energia Solar', href: '/financiamento-energia-solar' },
  { name: 'Financiamento Imobiliário (SFI)', href: '/financiamento-imobiliario' }
]

export const helpFaqs: HelpFaq[] = [
  {
    id: 'faq-confiavel',
    question: 'A CashMe é confiável?',
    answer: (
      <S.Answer>
        <Text size="body2" color={answerColor}>
          A CashMe é uma empresa do <strong>Grupo Cyrela</strong>. Com 7 anos de atuação no mercado, é pioneira e
          especialista em <strong>Empréstimo com Garantia de Imóvel</strong> no Brasil. Conheça{' '}
          <S.InlineLink
            href="/quem-somos"
            onClick={() =>
              pushDataLayer({
                category: 'Clique',
                action: 'Ajuda',
                label: 'Accordion Pergunta: A CashMe é confiável? - a história da CashMe aqui!'
              })
            }
          >
            a história da CashMe aqui!
          </S.InlineLink>
        </Text>
      </S.Answer>
    )
  },
  {
    id: 'faq-emprestimo',
    question: 'A CashMe é uma empresa de empréstimo?',
    answer: (
      <S.Answer>
        <Text size="body2" color={answerColor}>
          A CashMe é uma fintech especialista em Crédito com Garantia de Imóvel, mas oferece outras soluções
          financeiras e empréstimos. Conheça elas aqui:
        </Text>
        <S.ProductList>
          {otherProducts.map(({ name, href }) => (
            <S.ProductItem key={href}>
              <S.ProductBar aria-hidden />
              <S.ProductLink
                href={href}
                aria-label={`Saiba mais sobre ${name}`}
                onClick={() =>
                  pushDataLayer({
                    category: 'Clique',
                    action: 'Ajuda',
                    label: `Accordion Pergunta: A CashMe é uma empresa de empréstimo? - ${name}`
                  })
                }
              >
                <span>{name}</span>
                <ChevronRightIcon size={30} color="var(--colors-neutral-text-contrast-default)" />
              </S.ProductLink>
            </S.ProductItem>
          ))}
        </S.ProductList>
      </S.Answer>
    )
  },
  {
    id: 'faq-brasil',
    question: 'A CashMe atende a todo o Brasil?',
    answer: (
      <S.Answer>
        <Text size="body2" color={answerColor}>
          A CashMe tem operações 100% digitais, conseguindo atender à grande parte do Brasil. Para saber se a sua
          região é atendida,{' '}
          <SimulatorLink
            medium="Ajuda - faça uma simulação"
            dataLayer={{
              category: 'Clique',
              action: 'Ajuda',
              label: 'Accordion Pergunta: A CashMe atende a todo o Brasil? - faça uma simulação'
            }}
          >
            faça uma simulação de empréstimo sem compromisso
          </SimulatorLink>
          .
        </Text>
      </S.Answer>
    )
  },
  {
    id: 'faq-golpes',
    question: 'Como evitar golpes e fraudes financeiras?',
    answer: (
      <S.Answer>
        <Text size="body2" color={answerColor}>
          Caso receba qualquer cobrança antes da assinatura do contrato, não realize o pagamento e nos informe
          imediatamente. Entre em contato com a nossa central de atendimento ou com o seu consultor. Para saber como
          se proteger, confira{' '}
          <S.InlineLink
            href="/seguranca"
            onClick={() =>
              pushDataLayer({
                category: 'Clique',
                action: 'Ajuda',
                label: 'Accordion Pergunta: Como evitar golpes e fraudes financeiras? - nossas dicas de segurança digital'
              })
            }
          >
            nossas dicas de segurança digital
          </S.InlineLink>
          .
        </Text>
      </S.Answer>
    )
  },
  {
    id: 'faq-canais',
    question: 'Quais são os canais de atendimento?',
    answer: (
      <S.Answer>
        <Text size="body2" color={answerColor}>
          Os canais de atendimento oficiais são:
        </Text>
        <S.Contacts>
          <Text size="body2" color={answerColor}>
            Telefone e WhatsApp{' '}
            <S.ContactLink
              href="https://wa.me/551140402550"
              target="_blank"
              rel="noopener noreferrer"
              onClick={() =>
                pushDataLayer({
                  category: 'Clique',
                  action: 'Ajuda',
                  label: 'Accordion Pergunta: Quais são os canais de atendimento? - Telefone e WhatsApp'
                })
              }
            >
              (11) 4040-2550
            </S.ContactLink>
          </Text>
          <Text size="body2" color={answerColor}>
            E-mail{' '}
            <S.ContactLink
              href="mailto:fale.conosco@cashme.com.br"
              onClick={() =>
                pushDataLayer({
                  category: 'Clique',
                  action: 'Ajuda',
                  label: 'Accordion Pergunta: Quais são os canais de atendimento? - E-mail'
                })
              }
            >
              fale.conosco@cashme.com.br
            </S.ContactLink>
          </Text>
        </S.Contacts>
      </S.Answer>
    )
  },
  {
    id: 'faq-como-fazer',
    question: 'Como fazer Empréstimo com Garantia de Imóvel?',
    answer: (
      <S.Answer>
        <Text size="body2" color={answerColor}>
          É muito simples, basta fazer uma simulação! Um de nossos especialistas financeiros vai analisar o seu
          cenário atual gratuitamente e apresentar a proposta mais segura para você. Preencha os dados solicitados e
          descubra suas possibilidades.{' '}
          <SimulatorLink
            medium="Ajuda - Simule clicando aqui"
            dataLayer={{
              category: 'Clique',
              action: 'Ajuda',
              label: 'Accordion Pergunta: Como fazer Empréstimo com Garantia de Imóvel? - Simule clicando aqui'
            }}
          >
            Simule clicando aqui.
          </SimulatorLink>
        </Text>
      </S.Answer>
    )
  },
  {
    id: 'faq-juros',
    question: 'Como funcionam as taxas de juros na CashMe?',
    answer: (
      <S.Answer>
        <Text size="body2" color={answerColor}>
          A CashMe, por exemplo, não trabalha com uma taxa fixa divulgada publicamente. Isso acontece porque as
          condições de crédito são personalizadas para cada cliente. Saiba mais em{' '}
          <S.InlineLink
            href="/blog/taxa-de-juros-para-home-equity/"
            onClick={() =>
              pushDataLayer({
                category: 'Clique',
                action: 'Ajuda',
                label:
                  'Accordion Pergunta: Como funcionam as taxas de juros na CashMe? - Taxa de Juros para Home Equity'
              })
            }
          >
            Taxa de Juros para Home Equity: Tudo Que Você Precisa Saber
          </S.InlineLink>
          .
        </Text>
      </S.Answer>
    )
  }
]
